import {
  Component,
  Inject,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { UtilsService } from '../../shared/utils.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SitesSelectorComponent } from '../../shared/sites-selector/sites-selector.component';
import { RBACService } from '../../shared/rbac.service';

@Component({
  selector: 'app-sites-hazardous-substances-filter',
  templateUrl: './hazardous-substances-filter.component.html',
  styleUrls: ['./hazardous-substances-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HazardousSubstancesFilterComponent implements OnInit {
  /**
   * The filter object and default values.
   */
  filters: {
    parent_site_id: number;
    site_ids: number[] | string;
    hazardous_substance_type: string;
  } = {
    parent_site_id: null,
    site_ids: [],
    hazardous_substance_type: ''
  };

  // RBAC permission flag. Resolved once in ngOnInit() so the template does not
  // re-evaluate the permission check on every change detection cycle.
  canViewSites: boolean = false;

  constructor(
    public utils: UtilsService,
    public rbac: RBACService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<HazardousSubstancesFilterComponent>
  ) {}

  ngOnInit() {
    // Resolve RBAC permission flags.
    this.canViewSites = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_SITES,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    // Store the incoming values.
    this.filters.parent_site_id = this.data['parent_site_id'] || null;
    this.filters.site_ids = this.data['selected_site_ids'] || [];
    this.filters.hazardous_substance_type =
      this.data['hazardous_substance_type'] || '';
  }

  /**
   * Open the site selector.
   */
  onSelectSites() {
    this.utils
      .showComponentDialog(
        SitesSelectorComponent,
        {
          parent_site_id: this.filters.parent_site_id,
          selected: this.filters.site_ids,
          multiple: true
        },
        {
          width: '1200px'
        }
      )
      .then((results) => {
        if (typeof results !== 'undefined') {
          this.filters.site_ids = results;
        }
      });
  }

  /**
   * Clear the filters and close the dialog.
   */
  onClearAndClose() {
    this.filters.site_ids = [];
    this.filters.hazardous_substance_type = '';
    // Close the dialog.
    this.onSaveAndClose();
  }

  /**
   * Close the dialog and send the filters back.
   */
  onSaveAndClose() {
    this.dialogRef.close(this.filters);
  }

  onClose() {
    this.dialogRef.close();
  }

  // Expose RBACService to template.
  protected readonly RBACService = RBACService;
}
